// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Modal from "../../resources/overlays/Modal.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Scalar from "../../core/Scalar.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation CustomerArchiveModalArchiveMutation($id: ID!)  {\narchiveCustomer(id: $id)  {\n__typename  \nid  \narchivedAt  \n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.archiveCustomer;
  let value$2 = value$1.archivedAt;
  return {
    archiveCustomer: {
      __typename: value$1.__typename,
      id: value$1.id,
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined
    }
  };
}

function serialize(value) {
  let value$1 = value.archiveCustomer;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let archiveCustomer = {
    __typename: value$4,
    id: value$3,
    archivedAt: archivedAt
  };
  return {
    archiveCustomer: archiveCustomer
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id
  };
}

function makeVariables(id, param) {
  return {
    id: id
  };
}

let ArchiveCustomerMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let ArchiveCustomerMutation_useWithVariables = include.useWithVariables;

let ArchiveCustomerMutation = {
  ArchiveCustomerMutation_inner: ArchiveCustomerMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  makeVariables: makeVariables,
  use: use,
  useWithVariables: ArchiveCustomerMutation_useWithVariables
};

let Raw$1 = {};

let query$1 = Client.gql(["mutation CustomerArchiveModalUnarchiveMutation($id: ID!)  {\nunarchiveCustomer(id: $id)  {\n__typename  \nid  \narchivedAt  \n}\n\n}\n"]);

function parse$1(value) {
  let value$1 = value.unarchiveCustomer;
  let value$2 = value$1.archivedAt;
  return {
    unarchiveCustomer: {
      __typename: value$1.__typename,
      id: value$1.id,
      archivedAt: !(value$2 == null) ? Scalar.Datetime.parse(value$2) : undefined
    }
  };
}

function serialize$1(value) {
  let value$1 = value.unarchiveCustomer;
  let value$2 = value$1.archivedAt;
  let archivedAt = value$2 !== undefined ? Scalar.Datetime.serialize(value$2) : null;
  let value$3 = value$1.id;
  let value$4 = value$1.__typename;
  let unarchiveCustomer = {
    __typename: value$4,
    id: value$3,
    archivedAt: archivedAt
  };
  return {
    unarchiveCustomer: unarchiveCustomer
  };
}

function serializeVariables$1(inp) {
  return {
    id: inp.id
  };
}

function makeVariables$1(id, param) {
  return {
    id: id
  };
}

let UnarchiveCustomerMutation_inner = {
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1
};

let include$1 = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query$1,
  Raw: Raw$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1
});

let use$1 = include$1.use;

let UnarchiveCustomerMutation_useWithVariables = include$1.useWithVariables;

let UnarchiveCustomerMutation = {
  UnarchiveCustomerMutation_inner: UnarchiveCustomerMutation_inner,
  Raw: Raw$1,
  query: query$1,
  parse: parse$1,
  serialize: serialize$1,
  serializeVariables: serializeVariables$1,
  makeVariables: makeVariables$1,
  use: use$1,
  useWithVariables: UnarchiveCustomerMutation_useWithVariables
};

let archiveText = "Once the customer is archived, it will only be visible in the customer list by applying the \"Archived\" status filter.";

let unarchiveText = "Once the customer is unarchived, it will be visible again in the customer list.";

function CustomerArchiveModal(props) {
  let onCompleted = props.onCompleted;
  let onRequestClose = props.onRequestClose;
  let status = props.status;
  let id = props.id;
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let archiveCustomer = match[0];
  let match$1 = use$1(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let unarchiveCustomer = match$1[0];
  let onSuccess = () => {
    onRequestClose();
    Stdlib_Option.forEach(onCompleted, onCompleted => onCompleted());
  };
  let commit = param => {
    if (status === "Active") {
      Future.tapOk(ApolloHelpers.mutationPromiseToFutureResult(archiveCustomer(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
        id: id
      })), param => onSuccess());
      return;
    }
    Future.tapOk(ApolloHelpers.mutationPromiseToFutureResult(unarchiveCustomer(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id
    })), param => onSuccess());
  };
  let tmp;
  tmp = status === "Active" ? I18n.t(archiveText) : I18n.t(unarchiveText);
  let tmp$1;
  tmp$1 = status === "Active" ? I18n.t("Confirm the archiving of this customer") : I18n.t("Confirm the unarchiving of this customer");
  return JsxRuntime.jsx(Modal.make, {
    children: JsxRuntime.jsx(Box.make, {
      children: JsxRuntime.jsx(TextStyle.make, {
        children: tmp,
        variation: "normal"
      }),
      spaceX: "xlarge",
      spaceY: "xxlarge"
    }),
    opened: props.opened,
    title: tmp$1,
    abortButtonText: I18n.t("Cancel"),
    commitButtonText: I18n.t("Confirm"),
    commitButtonCallback: commit,
    onRequestClose: onRequestClose
  });
}

let make = React.memo(CustomerArchiveModal);

export {
  ArchiveCustomerMutation,
  UnarchiveCustomerMutation,
  archiveText,
  unarchiveText,
  make,
}
/* query Not a pure module */
